import { __require as requireFunctionName } from './node_modules-core-js-internals-function-name.js';
import { __require as requireFails } from './node_modules-core-js-internals-fails.js';
import { __require as requireWhitespaces } from './node_modules-core-js-internals-whitespaces.js';

var stringTrimForced;
var hasRequiredStringTrimForced;

function requireStringTrimForced () {
	if (hasRequiredStringTrimForced) return stringTrimForced;
	hasRequiredStringTrimForced = 1;
	var PROPER_FUNCTION_NAME = requireFunctionName().PROPER;
	var fails = requireFails();
	var whitespaces = requireWhitespaces();

	var non = '\u200B\u0085\u180E';

	// check that a method works with the correct list
	// of whitespaces and has a correct name
	stringTrimForced = function (METHOD_NAME) {
	  return fails(function () {
	    return !!whitespaces[METHOD_NAME]()
	      || non[METHOD_NAME]() !== non
	      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
	  });
	};
	return stringTrimForced;
}

export { requireStringTrimForced as __require };
//# sourceMappingURL=node_modules-core-js-internals-string-trim-forced.js.map
